module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active-assignment"
  }, [_c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.class_assignment',
      "count": _vm.activeAssignments.length,
      "routeName": 'cat-assignment',
      "eventLabel": 'assignments.view_more'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " cl-container"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "dummy-assignment"
  }, [_c('div', {
    staticClass: "dummy-assignment-image"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dummy-assignment-date"
  })]) : [(!_vm.isActiveAssignments) ? _c('div', {
    staticClass: "empty-assignment"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/img_empty_assignment.png',
      "alt": "empty-assignment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.empty_assignment')))])]) : _c('Assignment', {
    attrs: {
      "eventLabel": 'assignment',
      "assignments": _vm.filterActiveAssginments,
      "isBlock": false
    }
  })]], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dummy-assignment-content"
  }, [_c('div', {
    staticClass: "dummy-assignment-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-assignment-subtitle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77370542","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/ActiveAssignment.vue
// module id = 1594
// module chunks = 1